// Date helpers shared across hotel search & booking forms
export const todayISO = () => new Date().toISOString().split("T")[0];

export const addDaysISO = (iso, days) => {
    const d = new Date(iso || todayISO());
    d.setDate(d.getDate() + days);
    return d.toISOString().split("T")[0];
};

/**
 * Given a previous state and a new check_in, return updated {check_in, check_out}
 * ensuring check_out is at least 1 day after check_in.
 */
export const ensureValidRange = (prev, newCheckIn) => {
    const ci = newCheckIn || prev.check_in || todayISO();
    const minOut = addDaysISO(ci, 1);
    const co = !prev.check_out || new Date(prev.check_out) <= new Date(ci) ? minOut : prev.check_out;
    return { check_in: ci, check_out: co };
};

export const minCheckout = (checkIn) => addDaysISO(checkIn, 1);

export const nightsBetween = (ci, co) => {
    try {
        const a = new Date(ci);
        const b = new Date(co);
        return Math.max(1, Math.round((b - a) / 86400000));
    } catch { return 1; }
};
